<template lang='pug'>
  #dashboard
    .container
      router-view(v-slot="{ Component }")
        transition(name="fade" mode="out-in")
          component(:is="Component")

</template>

<script>
  import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
  import siftPageLoadMixin from "../../mixins/siftPageLoadMixin";
  import dataToolSvc from "@services/dataToolSvc";

  export default {
    name: "Dashboard",

    mixins: [ siftPageLoadMixin ],

    computed: {
      ...mapState('customer', [
        'cdata',
      ]),

      ...mapGetters('customer', [
        'isCustomerPresent',
      ]),

      ...mapState('global', [
        'windowData',
        'showNavs',
      ]),

      ...mapState('siteNav', [
        'navItems',
      ]),

      ...mapState('colorbar', ['showBopis']),
    },

    created() {
      if (this.$cookies.get('showBOPIS')) {
        this.setShowBopis(!!this.$cookies.get('showBOPIS'));
      }

      dataToolSvc.getData({ mixinKey: 'dashboard_config' }).then(res => {
        this.setCmsSettings(res.data);
      });

      this.refreshCustomerCdata();
    },

    mounted() {
      // periodically check timeout cookie and reload if expired
      setInterval(() => {
        if (!this.$cookies.get(this.$root.MRConfig.timeoutCookie)) {
          location.reload();
        }
      }, 1000 * 60 * 60 * 2); // 2 hours
    },

    methods: {
      ...mapActions('customer', ['refreshCustomerCdata']),

      ...mapMutations('colorbar', ['setShowBopis']),
      
      ...mapMutations('cms', ['setCmsSettings']),
    },
  };
</script>

<style scoped lang="stylus">
  #dashboard
    min-height 70vh

  .fade-enter-active,
  .fade-leave-active
    transition opacity .3s

  .fade-enter
    opacity 0

</style>